import { Outlet } from 'react-router-dom';
import React from 'react';

const AdminApp = () => {
	return (
		<>
            <Outlet />
		</>
	);
}

export default AdminApp;
